import React, { FC, useState, useRef, useEffect } from 'react'
import { IonPage, IonFooter, IonContent, useIonViewDidEnter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import ActivityApi from '@api/activity.api'
import MemberApi from 'api/member.api'
import { useHistoryNew, getCouponsInfo, modalLayer } from '@utils'
import { memberMobx } from '@mobxStore'
import { CouponItem, CouponDetail, TipModal, CouponSuccModal } from '@cps'
import { ddayjs } from '@dt/fe-utils'
import { each, keyBy } from '@dt/fe-utils/dist/lodash'
import mktController from 'controllers/mktController'
import i18n from 'i18next'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const CouponModal: FC<IProps> = ({ match }) => {
  const { logId } = match.params as any
  const history = useHistoryNew()
  const desRef: any = useRef<any>(null)
  const { isLogin, memberInfo } = memberMobx
  const [logInfo, setLogInfo] = useState<any>(null)
  const [activeInfo, setActiveInfo] = useState<any>(null)
  const [couponList, setCouponList] = useState<any[]>([])
  const [couponMap, setCouponMap] = useState<any>({})
  const [desUnfold, setDesUnfold] = useState<boolean>(false)
  const [hasUnfold, setHasUnfold] = useState<boolean>(false)
  const [activeStatus, setActiveStatus] = useState<boolean>(true)
  let posting = false
  const getCoupons = () => {
    if (isLogin) {
      if (logInfo.memberId || !activeStatus) {
        history.replace('/my')
      } else {
        if (memberInfo.type !== 'member') {
          mktController.jumpBind(history, 'all')
        } else {
          if (posting) return
          posting = true
          MemberApi.acquireWechatConcernCoupon({
            brandId: memberMobx.brandId,
            logId: Number(logId),
          }).then(() => {
            modalLayer(CouponSuccModal, {
              name: activeInfo.activityName,
              title: i18n.t('mkt.coupon.receivedSucc'),
              des: i18n.t('mkt.redeem.getCouponsNumber', { cnt: getCouponsInfo(couponList, 'cnt', couponMap) })
            }).then(() => {
              history.replace('/my')
            })
            posting = false
          }).catch((error: any) => {
            let text: string = i18n.t('mkt.coupon.getFail')
            if (error.code === 4006) {
              text = i18n.t('mkt.coupon.getSuccess', { name: activeInfo.activityName })
            }
            modalLayer(TipModal, {
              content: text
            }).then(() => {
              getData()
            })
            posting = false
          })
        }
      }
    } else {
      history.push('/login')
    }
  }
  const goDetail = (data: any) => {
    modalLayer(CouponDetail, { type: 'get', couponInfo: data }, 'couponDetail')
  }
  const getData = () => {
    MemberApi.getOneMemberCouponGetLog({
      logId: Number(logId),
    }).then((res: any) => {
      setLogInfo(res)
      ActivityApi.getActiveDetail(res.outId).then((activeRes: any) => {
        setActiveInfo(activeRes)
        if (activeRes.status === 'disable' || ddayjs().valueOf() > ddayjs(activeRes.endTime).valueOf()) {
          setActiveStatus(false)
        }
      })
      setCouponList(res.coupons)
      const couponArr: any = []
      each(res.coupons, (item: any) => couponArr.push(item.couponId))
      ActivityApi.getCouponsList({
        couponIds: couponArr,
      }).then((cRes: any) => {
        setCouponMap(keyBy(cRes, 'couponId'))
      })
    })
  }
  useIonViewDidEnter(() => {
    getData()
  })
  useEffect(() => {
    if (desRef && desRef.current) {
      if (desRef.current.scrollHeight > 38) {
        setHasUnfold(true)
      }
    }
    if (activeInfo) {
      const url = location.href
      mktController.initShareData({
        url: url,
        title: activeInfo.activityName,
        des: activeInfo.extra?.copywriting,
        img: activeInfo.playbill,
      })
    }
  }, [activeInfo])
  return (
    <IonPage className='wechat-coupon-page'>
      <IonContent className='page-content'>
        <div className='page-body'>
          {
            activeInfo &&
              <>
                {
                  activeInfo.playbill &&
                    <div className='active-img'>
                      <img src={activeInfo.playbill} alt='' />
                    </div>
                }
                <div className='active-info'>
                  <div className='title'>
                    <span>{activeInfo.activityName}</span>
                  </div>
                  {
                    activeInfo.extra && activeInfo.extra.copywriting
                      ? (
                        <div
                          ref={desRef}
                          className={`des ${desUnfold ? '' : 'unfold'}`} onClick={() => {
                            setDesUnfold(!desUnfold)
                          }}
                        >
                          {activeInfo.extra.copywriting}
                          {
                            hasUnfold &&
                              <div className='unfold-icon' style={{ transform: ` rotate(${desUnfold ? '180deg' : '0deg'})` }}>
                                <i className='iconfont icon-caret--down'></i>
                              </div>
                          }
                        </div>) : ''
                  }
                </div>
              </>
          }
          <div className='coupon-area'>
            {
              couponList.map((item: any) => {
                const couponInfo: any = couponMap[item.couponId]
                return couponInfo && (
                  <div className='coupon-block' key={item.couponId}>
                    <CouponItem type='get' couponInfo={couponInfo} cnt={item.couponCnt} onClick={goDetail}></CouponItem>
                  </div>
                )
              })
            }
          </div>
        </div>
      </IonContent>
      <IonFooter>
        <div className='page-footer'>
          <div className='receive-btn' onClick={getCoupons}>
            <div className='title'>
              {isLogin &&
                <>
                  {
                    logInfo && logInfo.memberId ? (
                      <>
                        {logInfo.memberId === memberMobx.memberInfo.memberId ? i18n.t('mkt.coupon.myCoupon') : i18n.t('mkt.coupon.received')}
                      </>)
                      : (
                        <>
                          {activeStatus ? i18n.t('mkt.coupon.getCouponsNow') : i18n.t('mkt.market.eventIsOver')}
                        </>)
                  }
                </>}
              {!isLogin && i18n.t('mkt.market.receiveAfterLogin')}
            </div>
            {!isLogin && <div className='des'>{i18n.t('mkt.coupon.onlyForMember')}</div>}
          </div>
        </div>
      </IonFooter>
    </IonPage>
  )
}

export default observer(CouponModal)
